import momentJalali from 'moment-jalaali';
import moment from 'moment';
import PidoCarOnline from '../assets/images/pidoCarOnline.png';
import FuelRequestImg from '../assets/images/fuelStation.png';
import LoadingFuel from '../assets/images/loadingFuel.png';
import Incentive from '../assets/images/incentive.png';
import Financial from '../assets/images/financial.png';
import CarRepair from '../assets/images/carRepair.png';
import MarkerPin from '../assets/images/pin.svg';
import packageJson from '../../package.json';
import * as router from '../constants/router';
import * as constants from '../constants';
import IntlMessages from './IntlMessages';
import * as regex from './regex';
import config from './config';
import * as db from './db';

const initMapBox = (params) => {
  return {
    latitude: params.latitude,
    longitude: params.longitude,
    zoom: params.zoom || config.mapbox.zoom,
    width: params.width || '100vw',
    height: params.height || '100vh',
    bearing: config.mapbox.bearing,
    pitch: config.mapbox.pitch,
  };
};

const getVersion = () => packageJson.version;

const getContentBlankPage = (type) => {
  switch (type) {
    case constants.BLANK_PAGE_CAR_REPAIR:
      return {
        image: CarRepair,
        message: <IntlMessages id="noTankerFailureHasBeenRegisteredForYouInSystem" />,
      };
    case constants.BLANK_PAGE_REFUELING_TANKER:
      return {
        image: LoadingFuel,
        message: <IntlMessages id="fuelRefuelingWasNotFoundForYou" />,
      };
    case constants.BLANK_PAGE_FINANCIAL:
      return {
        image: Financial,
        message: <IntlMessages id="financialPartWillBeAvailableToYouSoon" />,
      };
    case constants.BLANK_PAGE_INCENTIVE:
      return {
        image: Incentive,
        message: <IntlMessages id="thereIsNoIncentivePlanForYou" />,
      };
    case constants.BLANK_PAGE_FUEL_REQUEST_LOCAL:
      return {
        image: FuelRequestImg,
        message: <IntlMessages id="anLocalRequestHasNotForYou" />,
      };
    case constants.BLANK_PAGE_FUEL_REQUEST_ONLINE:
      return {
        image: FuelRequestImg,
        message: <IntlMessages id="anOnlineRequestHasNotForYou" />,
      };
    case constants.BLANK_PAGE_FUEL_REQUEST_RESERVE:
      return {
        image: FuelRequestImg,
        message: <IntlMessages id="anReserveRequestHasNotForYou" />,
      };
    case constants.BLANK_PAGE_FUEL_REQUEST_ORGANIZATION:
      return {
        image: FuelRequestImg,
        message: <IntlMessages id="anOrganizationRequestHasNotForYou" />,
      };
    default:
      break;
  }
};

const fuelRequestComponentFormatData = (data) => {
  switch (data.type) {
    case 'local':
      return {
        vRequestCode: data.vFuelCarCode + ' - ' + data.vTerminalName,
        dtAddAt: miladiTojalali(data.dtAddAt),
        iVolume: numberformat(data.iVolumeReceived),
        iAmount: numberformat(data.iTotalPrice),
        vMessage: numberformat(data.iTotalPrice) + ' ( ' + data.vFuelInfoTitle + ' )',
      };
    case 'organization':
      return {
        vRequestCode: data.vRequestCode,
        dtAddAt: miladiTojalali(data.dtDeliveryDate),
        iVolume: numberformat(data.iVolumeReceived),
        iAmount: numberformat(data.iTotalPrice),
        vMessage: numberformat(data.iTotalPrice) + ' ( ' + data.vFuelInfoTitle + ' )',
      };
    case 'organizationInprocess':
      return {
        vRequestCode: data.vRequestCode,
        dtAddAt: miladiTojalali(data.dtAddAt),
        iVolume: numberformat(
          data.iVolumeReceived !== -1 ? data.iVolumeReceived : data.iVolumeRequested,
        ),
        iAmount: numberformat(data.iTotalPrice),
        vMessage: data.vOrganizationName,
      };
    case 'onlineInprocess':
      return {
        vRequestCode: data.vRequestCode,
        dtAddAt: miladiTojalali(data.dtAddAt),
        iVolume: numberformat(
          data.iVolumeReceived === 0 ? data.iVolumeRequested : data.iVolumeReceived,
        ),
        iAmount: numberformat(data.iTotalPrice),
        vMessage: data.vAddress,
      };
    default:
      return {
        vRequestCode: data.vRequestCode,
        dtAddAt: miladiTojalali(data.dtAddAt),
        iVolume: numberformat(data.iVolumeReceived),
        iAmount: numberformat(data.iTotalPrice),
        vMessage: numberformat(data.iTotalPrice) + ' ( ' + data.vFuelInfoTitle + ' )',
      };
  }
};

const miladiTojalali = (datetime, format = 'datetime') => {
  if (moment(datetime).isValid()) {
    let time = moment(datetime).format('HH:mm:ss');
    let date = moment(datetime).format('YYYY-MM-DD');
    date = momentJalali(date).format('jYYYY/jMM/jDD');
    return format === 'datetime' ? time + ' | ' + date : date;
  } else return '';
};

const numberformat = (number) => Intl.NumberFormat().format(number);

const getSalesContent = () => {
  return [
    {
      image: FuelRequestImg,
      title: <IntlMessages id="refuelingTanker" />,
      link: router.REFUELING_TANKER,
    },
    {
      image: FuelRequestImg,
      title: <IntlMessages id="onlineSale" />,
      link: router.SALES_ONLINE,
    },
    {
      image: FuelRequestImg,
      title: <IntlMessages id="localSale" />,
      link: router.SALES_LOCAL,
    },
    {
      image: FuelRequestImg,
      title: <IntlMessages id="onlineOrganization" />,
      link: router.SALES_ORGANIZATION,
    },
  ];
};

const getHttpRequestHeader = (headers) => {
  let authorization = db.getConfig();
  let apptype = config.apptype;
  let appversion = getVersion();
  let client_ip = db.getIpAddress();
  return authorization && authorization
    ? {
        'Content-Type': 'application/json',
        authorization,
        appversion,
        apptype,
        client_ip,
        ...headers,
      }
    : headers;
};

const getHttpRequestUrl = (serviceName) => {
  let serviceNameWithVersion = setVersionApi(serviceName);
  return process.env.REACT_APP_API_URL + serviceNameWithVersion;
};

const setVersionApi = (serviceName) => {
  let arrServiceName = serviceName.split('/');
  if (arrServiceName.length === 2) {
    return arrServiceName[0] + '/' + config.api.default + '/' + arrServiceName[1];
  }
  return serviceName;
};

const getHttpResponseSuccess = (response) => {
  if (typeof response !== 'undefined' && typeof response.data !== 'undefined') {
    response = response.data;
    let data = response.data || [];
    let message = response.settings.message || '';
    let status = response.settings.success;
    let totalCount = response.settings.totalCount || 0;

    return {
      status: parseInt(status) === 1 ? true : false,
      errorCode: response.settings.success,
      data,
      message,
      totalCount,
    };
  } else
    return {
      status: false,
      errorCode: 0,
      message: <IntlMessages id="noInformationWasReceivedFromServer" />,
      data: [],
      totalCount: 0,
    };
};

const getHttpResponseMessageError = (response) => {
  if (typeof response !== 'undefined') {
    return response.settings.message || '';
  }
  return <IntlMessages id="noInformationWasReceivedFromServer" />;
};
const getMapIcon = (type) => {
  switch (type) {
    case constants.MAP_LOCATION_CAR_ONLINE:
      return PidoCarOnline;
    default:
      return MarkerPin;
  }
};

const telFormat = (mobile) => {
  if (typeof mobile !== 'undefined' && !regex.MOBILE.test(mobile)) return '';
  else return 'tel:0' + mobile.substr(-10);
};

const navigationLink = (latitude, longitude, type = 'google') => {
  switch (type) {
    case 'google':
      return 'https://www.google.com/maps?daddr=' + latitude + ',' + longitude;
    case 'balad':
      return (
        'https://balad.ir/location?latitude=' +
        latitude +
        '&longitude=' +
        longitude +
        '&zoom=16.500000'
      );
    default:
      return 'https://www.google.com/maps?daddr=' + latitude + ',' + longitude;
  }
};

const mapConfig = () => {
  let type = db.getMapConfig();
  switch (type) {
    case constants.MAP_TYPE_MAPGL:
      return config.mapbox.mapgl;
    case constants.MAP_TYPE_PARSIMAP:
      return config.mapbox.parsimap;
    default:
      return config.mapbox.parsimap;
  }
};

const getSalesDetailsTitle = (type) => {
  switch (type) {
    case 'local':
      return <IntlMessages id="viewLocalSalesReport" />;
    case 'organiztion':
      return <IntlMessages id="viewOrganizationSalesReport" />;
    case 'fuel':
      return <IntlMessages id="viewRefuelingReportsFromStation" />;
    default:
      return <IntlMessages id="viewOnlineSalesReport" />;
  }
};

const getPaymentType = (paymentType) => {
  switch (paymentType) {
    case 0:
      return <IntlMessages id="cash" />;
    default:
      return <IntlMessages id="credit" />;
  }
};

const getReceiptStatus = (status) => {
  switch (status) {
    case 0:
      return <IntlMessages id="getReceipt" />;
    default:
      return <IntlMessages id="noReceipt" />;
  }
};

const getFuelCarRepairStatus = (status) => {
  switch (status) {
    case 1:
      return <IntlMessages id="pending" />;
    case 2:
      return <IntlMessages id="notApproved" />;
    case 3:
      return <IntlMessages id="confirmedSales" />;
    case 4:
      return <IntlMessages id="assignRepairman" />;
    case 5:
      return <IntlMessages id="completeRepairWork" />;
    case 6:
      return <IntlMessages id="completed" />;
    default:
      return <IntlMessages id="pending" />;
  }
};

const logger = (data, type = 'log') => {
  if (process.env.NODE_ENV !== 'production') {
    switch (type) {
      case 'info':
        console.info(JSON.stringify(data));
        break;
      case 'error':
        console.error(JSON.stringify(data));
        break;
      case 'warn':
        console.warn(JSON.stringify(data));
        break;
      case 'log':
        console.log(JSON.stringify(data));
        break;
      default:
        console.log(JSON.stringify(data));
        break;
    }
  }
};

const clearCacheData = () => {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
    if (process.env.NODE_ENV === 'production') window.location.reload();
  });
};

export {
  logger,
  telFormat,
  mapConfig,
  getVersion,
  initMapBox,
  getMapIcon,
  numberformat,
  clearCacheData,
  navigationLink,
  getPaymentType,
  miladiTojalali,
  getSalesContent,
  getReceiptStatus,
  getHttpRequestUrl,
  getContentBlankPage,
  getHttpRequestHeader,
  getSalesDetailsTitle,
  getHttpResponseSuccess,
  getFuelCarRepairStatus,
  getHttpResponseMessageError,
  fuelRequestComponentFormatData,
};
